module.exports = __webpack_public_path__ + "static/media/Adesh_CV.4959e24e.PDF";